import { useEffect, useState } from 'react'

import { loadFlags } from '@/services/feature-flag'
import { loadAppSessionId, setLocale, setStack } from '@/stores/config'

import { AppProps } from '@/types/app-props'
import { getCommonsNorthboundAPIs } from '@foreign-clientos/dependency-manager'

export function useInitApp(props: AppProps, bundleName: string) {
  const [initialized, setInitialized] = useState(false)
  const { setSidebarVisibility } =
    getCommonsNorthboundAPIs().v1.store.state.onboarding

  useEffect(() => {
    setStack(props.stack)
    setLocale(getCommonsNorthboundAPIs().v1.localization)
    /**
     * Controls sidebar visibility (@jarvis/oobe-layout) based on bundle name.
     * This mitigates layout limitations caused by sharing a single service ID across experiences
     * with different layout requirements. This is needed until service ID is split down to
     * meet different VX combinations.
     *
     * Sidebar is visible unless the bundle is 'account-value prop' or 'landing-page'.
     * This allows a unified layout configuration for experiences using @jarvis/oobe-layout.
     * If layout configuration is not leveraging side bar then this is a no-op.
     */
    setSidebarVisibility?.(
      !['account-value-prop', 'landing-page'].includes(bundleName),
    )
    Promise.all([
      /**
       * All promises needed to be resolved before the initialization of the app should be added here
       */
      loadFlags(),
      loadAppSessionId(),
    ]).then(() => setInitialized(true))
  }, [])

  return initialized
}
